import { createAsyncThunk } from "@reduxjs/toolkit";
import { notificationPreferencesService } from "../services/notificationPreferences.service";
import { handleRejectError } from "../../../utils/api/api.utils";
import type {
  NotificationPreferenceScope,
  NotificationPreferencesMap,
} from "../interfaces/notificationPreferences.interface";

export const fetchNotificationPreferences = createAsyncThunk(
  "notificationPreferences/fetch",
  async (scope: NotificationPreferenceScope, { rejectWithValue }) => {
    try {
      const response = await notificationPreferencesService.getPreferences(scope);
      if (response.success && response.data) {
        return {
          scope,
          preferences: response.data.preferences || {},
        };
      }
      return rejectWithValue(
        response.message || "Failed to fetch notification preferences",
      );
    } catch (error: any) {
      return handleRejectError(rejectWithValue, error);
    }
  },
);

export const saveNotificationPreferences = createAsyncThunk(
  "notificationPreferences/save",
  async (
    payload: {
      scope: NotificationPreferenceScope;
      preferences: NotificationPreferencesMap;
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await notificationPreferencesService.savePreferences(
        payload.scope,
        payload.preferences,
      );
      if (response.success && response.data) {
        return {
          scope: payload.scope,
          preferences: response.data.preferences || {},
        };
      }
      return rejectWithValue(
        response.message || "Failed to save notification preferences",
      );
    } catch (error: any) {
      return handleRejectError(rejectWithValue, error);
    }
  },
);
